import DiscoverNav from './DiscoverNav';

export default DiscoverNav;
